<template>
    <div class="choose-summary" :class="{ 'active' : bikesInCart > 0}">
        <div>
            <p class="d-block m-0 text-uppercase">You have already chosen:</p>
            <h5 class="text-secondary">{{ bikesInCart }} bikes</h5>
        </div>
        <div>
            <a href="/checkout" class="btn btn-secondary text-capitalize">Go to checkout</a>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "ChooseSummary",
    props: {
        typeFilter: {
            type: String,
            required: false,
            default: 'rentals'
        }
    },
    computed: {
        ...mapGetters('cart', ['bikesNumber', 'eventBikesNumber']),
        bikesInCart() {
            if(this.typeFilter === 'events' ) {
                return this.eventBikesNumber;
            }

            return this.bikesNumber;
        }
    }
}
</script>

<style lang="scss" scoped>
.choose-summary {
    position: fixed;
    bottom: 0;
    z-index: 99;
    width: 100vw;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 0;
    background: var(--bs-white);
    flex-direction: row;
    transform: translateY(105%);
    transition: all 0.4s cubic-bezier(0.65, 0.05, 0.36, 1);
    box-shadow: 0 4px 4px var( --color-gray);

    &.active {
        transform: translateY(0);
    }
}
</style>
